import React, { Component } from "react";
import ToggleButton from 'react-toggle-button';

class ActiveToggleFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filterName: props.filterName,
      displayName: props.displayName,
      value: props.value,
      onChangeCallback: props.onChangeCallback,
      debounceTimeout: props.debounceTimeout || 500,
      useEqualsDisplayName: props.useEqualsDisplayName
    };

    this.onChange = this.onChange.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.clear !== this.props.clear) {
      this.setState({ value: false });
    }
    if (prevProps.value !== this.props.value) {
      this.setState({ value: this.props.value });
    }
  }

  onChange(value) {
    const filteredDisplay = value
      ? this.state.useEqualsDisplayName
        ? `${this.state.displayName}: ${value}`
        : `${this.state.displayName}: ${value}`
      : null;

    this.state.onChangeCallback({
      filterName: this.state.filterName,
      value: value,
      filteredDisplay: filteredDisplay
    });

    this.setState({
      value: value
    });
  }

  render() {
    return (
      <span>
        {this.state.displayName}
        <ToggleButton
          value={this.state.value}
          activeLabel={"Yes"}
          inactiveLabel={"No"}
          onToggle={(value) => {
            this.setState({
              value: !value
            }, this.onChange(!value));
          }}
        />
      </span>
    );
  }
}

export default ActiveToggleFilter;


// WEBPACK FOOTER //
// ./src/components/ActiveToggleFilter.js